<form [formGroup]="requestedDatesForm" >
    <div class="step-container">
      <ng-template #labelDates>{{ getTranslation('tentativeDates.title') }}</ng-template>
      <div class="step-title">
        {{ isEditable ? getTranslation('tentativeDates.title') : getTranslation('tentativeDates.blockedForEdit') }}
        <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
      </div>


      <div class="alert-box">
        <div class="alert-title">
          <i class="fas fa-info-circle" [nbTooltip]="getTranslation('tentativeDates.tooltip')" nbTooltipPlacement="top"></i>
          &nbsp; {{ getTranslation('tentativeDates.info.readBefore') }}
        </div>
        <div class="alert-text">
          <p>
            {{ getTranslation('tentativeDates.info.paragraph1a') }} 
              <!-- <strong>{{ getTranslation('tentativeDates.info.gsp') }}</strong>. -->
            {{ getTranslation('tentativeDates.info.paragraph1b') }}
            <strong>{{ getTranslation('tentativeDates.info.paragraph1c') }}</strong>
          </p>
        </div>
      </div>
      
      <div class="alert-box">
        <div class="alert-title">
          <i class="fas fa-info-circle" [nbTooltip]="getTranslation('tentativeDates.tooltip')" nbTooltipPlacement="top"></i>
          &nbsp; {{ getTranslation('tentativeDates.factors.title') }}
        </div>
        <div class="alert-text">
          <ul>
            <li><strong>{{ getTranslation('tentativeDates.factors.healthTitle') }}</strong> {{ getTranslation('tentativeDates.factors.healthText') }}</li>
            <li><strong>{{ getTranslation('tentativeDates.factors.weatherTitle') }}</strong> {{ getTranslation('tentativeDates.factors.weatherText') }}</li>
          </ul>
          <div><strong>{{ getTranslation('tentativeDates.factors.recentEventsTitle') }}</strong></div>
          <ul>
            <li>{{ getTranslation('tentativeDates.factors.recent.divorce') }}</li>
            <li>{{ getTranslation('tentativeDates.factors.recent.death') }}</li>
            <li>{{ getTranslation('tentativeDates.factors.recent.addictionRecovery') }}</li>
            <li>{{ getTranslation('tentativeDates.factors.recent.surgeryIllness') }}</li>
            <li>{{ getTranslation('tentativeDates.factors.recent.mentalHealthTreatment') }}</li>
          </ul>
        </div>
      </div>



      <div *ngIf="isJsonShow">
        <span>{{ requestedDatesForm.value | json }}</span>
      </div>

      <!-- Retreat Event Type Dropdown - Only for PTH -->
      <div class="row gx-2" *ngIf="isPTHApplication">
        <div class="form-group col-12 mb-3">
          <label for="inputRetreatEventId" class="form-label">
            {{ getTranslation('tentativeDates.retreatEventType') }} <span class="text-danger">*</span>
          </label>
          <ng-select
            [items]="retreatEventsList"
            [searchable]="true"
            formControlName="RetreatEventId"
            bindLabel="label"
            bindValue="value"
            [placeholder]="getTranslation('tentativeDates.selectRetreatEvent')"
            [clearable]="false"
            class="custom-ng-select"
            [ngClass]="{'is-invalid': submitted && requestedDatesForm.get('RetreatEventId')?.invalid}">
          </ng-select>
          <div *ngIf="submitted && requestedDatesForm.get('RetreatEventId')?.invalid" class="text-danger">
            {{ getTranslation('validation.retreatEventRequired') }}
          </div>
        </div>
      </div>

      <!-- <div class="option" formGroupName="option1">
        <h5>OPTION 1</h5>
        <div class="row gx-2">
          <div class="form-group col-6 mb-3">
            <label for="arrivalDate1">Arrival Date:</label>
            <input
              type="date"
              class="form-control"
              id="arrivalDate1"
              formControlName="arrivalDate"
            />
            <div *ngIf="submitted && requestedDatesForm.get('option1.arrivalDate')?.invalid" class="text-danger">
              <div *ngIf="requestedDatesForm.get('option1.arrivalDate')?.errors?.['required']">Arrival date is required.</div>
            </div>
          </div>
          <div class="form-group col-6 mb-3">
            <label for="departureDate1">Departure Date:</label>
            <input
              type="date"
              class="form-control"
              id="departureDate1"
              formControlName="departureDate"
            />
            <div *ngIf="submitted && requestedDatesForm.get('option1.departureDate')?.invalid" class="text-danger">
              <div *ngIf="requestedDatesForm.get('option1.departureDate')?.errors?.['required']">Departure date is required.</div>
            </div>
          </div>
        </div>
      </div>
   -->
    

   <div formArrayName="CommonArrivalScheduleRequestData">
    <div
      *ngFor="let schedule of arrivalScheduleDetails.controls; let i = index"
      [formGroupName]="i"
      class="row gx-2"
    >
 
      

      <!-- Requested Arrival Date -->
      <div class="form-group col-12 col-md-6 mb-3">
        <label for="inputRequestedArrivalDate{{ i }}" class="form-label">{{ getTranslation('tentativeDates.arrivalDate') }}</label>
        <app-custom-date-picker
          formControlName="RequestedArrivalDate"
          [placeholder]="getTranslation('tentativeDates.arrivalDatePlaceholder')"
          [maxDate]="schedule.get('RequestedDepartureDate')?.value"
        ></app-custom-date-picker>
        <div *ngIf="submitted && schedule.get('RequestedArrivalDate')?.invalid" class="text-danger">
          {{ getTranslation('validation.arrivalDateRequired') }}
        </div>
        <div *ngIf="submitted && schedule.errors?.['dateOrder']" class="text-danger">
          {{ getTranslation('tentativeDates.arrivalBeforeDeparture') }}
        </div>
      </div>
  
      <!-- Requested Departure Date -->
      <div class="form-group col-12 col-md-6 mb-3">
        <label for="inputRequestedDepartureDate{{ i }}" class="form-label">{{ getTranslation('tentativeDates.departureDate') }}</label>
        <app-custom-date-picker
          formControlName="RequestedDepartureDate"
          [placeholder]="getTranslation('tentativeDates.departureDatePlaceholder')"
          [minDate]="schedule.get('RequestedArrivalDate')?.value"
        ></app-custom-date-picker>
        <div *ngIf="submitted && schedule.get('RequestedDepartureDate')?.invalid" class="text-danger">
          {{ getTranslation('validation.departureDateRequired') }}
        </div>
        <div *ngIf="submitted && schedule.errors?.['dateOrder']" class="text-danger">
          {{ getTranslation('tentativeDates.departureAfterArrival') }}
        </div>
      </div>
  
      <!-- Save Mode -->
      <!-- <div class="form-group col-12 col-md-4 mb-3">
        <label for="inputSaveMode{{ i }}" class="form-label">Save Mode:</label>
        <input
          type="text"
          class="form-control"
          id="inputSaveMode{{ i }}"
          formControlName="SaveMode"
          placeholder="Enter Save Mode"
        />
        <div *ngIf="submitted && schedule.get('SaveMode')?.invalid" class="text-danger">
          Save Mode is required.
        </div>
      </div> -->
    </div>
  </div>


    </div>

      <!-- Buttons -->
   <!-- Buttons start -->
  <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" 
       *ngIf="!isPreviewMode && isEditable">
    <button type="button" class="btn savedraftbtn" 
            *ngIf="requestedDatesForm.get('SaveMode')?.value !== SaveMode.SAVE"
            (click)="onSubmit(SaveMode.DRAFT)">
      <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
    </button>
    <button type="button" class="btn prevbtn" (click)="goToBack()">
      <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
    </button>
    <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE)">
      <i class="fas fa-arrow-right mr-2"></i>{{ getTranslation('button.next') }}
    </button>
  </div>
  <!-- Buttons ends -->


  </form>
  